<h2>Org Team Members</h2>
<app-basic-action-table *ngIf="organizationList"
  dataName="Team Member"
  [columns]="columns"
  [actions]="actions"
  endpoint="teammember"
  [organizations]="organizationList"
  (actionEvent)="eventDetected($event)"
></app-basic-action-table>
